/** @format */

import { createAction, createReducer } from '@reduxjs/toolkit';

const initialState = {
  aggiornamentiData: { additionalInfo: {}, body: {}, info: {} }
};
export const updateAggData = createAction('updateAggData');

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(updateAggData, (state, action) => {
    state.aggiornamentiData = { ...state.aggiornamentiData, ...action.payload };
  });
});

export default reducer;
